/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from 'underscore';
import loader from './loader';

window.dataLayer = window.dataLayer || [];

const load = loader(() => {
    let d = document;
    let g = d.createElement('script');
    let s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.src = '//www.googletagmanager.com/gtag/js?id=AW-982977399';
    s.parentNode.insertBefore(g, s);
    window.dataLayer.push(["js", new Date()]);
});

export default function () {
    load();
    window.dataLayer.push(arguments);
}

